<template>
    <a-card>
        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="2">
                <a-icon type="control" />
            </a-col>
            <a-col :flex="3" justify="center">
                <p>Capacity</p>
            </a-col> 
        </a-row>

        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="3" justify="center">
                <a-slider :marks="marks" v-model="currentCapacity" :min="1" :max="15" @afterChange="handleChanged" :disabled="!isEnabled"/>   
            </a-col> 
        </a-row>
    </a-card> 
</template>

<script>
export default {
    props : {
        capacity : Number,
        isEnabled : Boolean
    },
    computed : {
        
    },
    data () {
        return {
            marks : {
                1 : '1',
                5 : '5',
                10 : '10',
                15 : {
                    style: {
                        color: '#f50',
                    },
                    label: 15,
                }
            },
            currentCapacity : this.capacity
        }
    },
    methods : {
        handleChanged(e) {
            this.$emit('changed', this.currentCapacity );
        }
    },

    watch: {
        capacity : {
            handler(newValue) {
                this.currentCapacity = newValue;
            },
            flush: 'post'
            
        }
    }
}
</script>

<style scoped>
.icons-list >>> .anticon {
  margin-right: 6px;
  font-size: 24px;
}
</style>
